<template>
  <section class="my-5">
    <h2>登録申込</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">申込登録</li>
        <li class="px-3">内容確認</li>
        <li class="px-3">商品注文</li>
        <li class="here px-3">カート確認</li>
        <li class="px-3">お届け/お支払</li>
        <li class="px-3">最終確認</li>
        <li class="px-3">申込完了</li>
      </ul>
    </div>
    <h3 class="form-ttl">ご注文確認</h3>
    <p class="exp">以下の内容でよろしければ次へ進むを押してください。</p>

    <div class="detail-cart border box-p-20 mt-5">
      <!-- <div class="cart_set mb-5">
        <dl class="mb-3">
          <dt>スターターセット</dt>
          <dd>スターターセットA</dd>
        </dl>
        <dl>
          <dt>プレゼント品</dt>
          <dd>プレゼント品A</dd>
        </dl>
      </div> -->
      <div class="d-flex py-3 border-bottom only_pc">
        <div class="shohin_group text-center">
          <p>商品</p>
        </div>
        <div class="shohin_quantity text-center">
          <p>個数</p>
        </div>
        <div class="shohin_price text-center">
          <p>価格</p>
        </div>
      </div>
      <div id="CartList">
        <ul>
          <ConfirmItem
            v-for="item in goods"
            :key="item.no"
            :item="item"
            @delCart="delCart"
            @putCart="putCart"
          ></ConfirmItem>
          <ConfirmItem
            v-for="item in tools"
            :key="item.no"
            :item="item"
            @delCart="delCart"
            @putCart="putCart"
          ></ConfirmItem>
          <ConfirmItem
            v-for="item in camps"
            :key="item.no"
            :item="item"
            @delCart="delCart"
            @putCart="putCart"
          ></ConfirmItem>
        </ul>
      </div>
      <!-- 動的HTML生成部 カート小計 -->
      <div id="CartSubtotal" class="d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>小計</p>
        </div>
        <div class="shohin_price text-right">
          <p>{{ itemAmount }}円</p>
        </div>
      </div>
      <div class="text-center pt-5">
        <router-link
          :to="{ path: '/shopping-in0001/order' }"
          class="btn d-inline-block"
          >他の商品を追加する</router-link
        >
      </div>
    </div>
    <div class="box-p-20 text-center mt-5">
      <button
        v-on:click="putData"
        id="btnNext"
        type="button"
        class="confirm-01"
      >
        次へ進む
      </button>
    </div>
  </section>

  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ mc-info@manavis-cosme.co.jp
    </p>
  </div>
</template>
<script>
import ConfirmItem from "./components/ConfirmItem";
import Request from "@/modules/Request";
let request = new Request();
export default {
  components: {
    ConfirmItem,
  },
  data() {
    return {
      goods: [],
      tools: [],
      camps: [],
      itemAmount: "",
    };
  },
  mounted() {
    this.getData();
    window.scroll(0, 0);
  },
  methods: {
    getData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getCart",
        [],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          let cartConfirm = data.CartConfirm;
          this.goods = cartConfirm.goods;
          this.tools = cartConfirm.tools;
          this.camps = cartConfirm.camps;
          this.itemAmount = cartConfirm.ItemAmount;
          this.collectFee = cartConfirm.CollectFee;
          this.carriageFee = cartConfirm.CarriageFee;
          this.total = cartConfirm.Total;
        });
    },
    putData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "canNextStep",
        [1],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          this.$router.push({
            path: "/shopping-in0001/delivery",
          });
        });
    },
    delCart(params) {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "delCart",
        params,
        true
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          this.getData();
        });
    },
    putCart(params) {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "putCart",
        params,
        true
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          this.getData();
        });
    },
  },
};
</script>

<style scoped>
.cart_set dl {
  display: flex;
  flex-wrap: wrap;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.cart_set dt {
  width: 300px;
  padding: 10px 15px;
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  background: #fafafa;
}
.cart_set dd {
  padding: 10px 15px;
  width: calc(100% - 300px);
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  .cart_set dt,
  .cart_set dd {
    width: 100%;
  }
}
</style>